// extracted by mini-css-extract-plugin
export default {"container":"DocumentCompletion_container__c8fSX","errorState":"DocumentCompletion_errorState__Pn03F","backButton":"DocumentCompletion_backButton__1h2Y7"};